<template>
    <div :id="data.id">{{data.id}}</div>
</template>

<script>
    export default {
        props: ['data'],

        components: {},

        data() {
            return {

            }
        },

        computed: {

        },

        methods: {

        }
    }
</script>
